module.exports = __webpack_public_path__ + "static/media/market.f8fee84e.png";